export default __webpack_public_path__ + "static/media/Arrow.a6aad04b.svg";